module.exports = __webpack_public_path__ + "static/media/weekly-statistics-icon.1e2860e4.svg";